export default __webpack_public_path__ + "static/blockchain-f49edaf5b69c86af527438759f5ca653.png";